// extracted by mini-css-extract-plugin
export default {"section":"style_section__C-Aa0","footer":"style_footer__G6p3q","hrThin":"style_hrThin__hsB2M","hr":"style_hr__NW33b","socialIcons":"style_socialIcons__4z-5k"};